/**
 * 运行时配置：统一从环境变量（.env）读取，避免在代码里散落硬编码地址。
 * 环境变量由 config/env.js 通过 webpack.DefinePlugin 注入为 process.env.VUE_APP_xxx。
 */
import site from '../seo/site'

/** 保证以 / 结尾，便于与 'user/login' 这类相对路径拼接 */
function normalizeBaseURL(url) {
  const value = String(url || '').trim()
  if (!value) return ''
  return value.replace(/\/+$/, '') + '/'
}

function toBool(value, fallback) {
  if (value === undefined || value === '') return fallback
  return String(value).toLowerCase() === 'true'
}

/** 后端接口根地址，例如 https://backend.workatdata.com/open/ */
export const API_BASE_URL = normalizeBaseURL(process.env.VUE_APP_API_BASE_URL)

/** axios 默认超时时间（毫秒） */
export const REQUEST_TIMEOUT = Number(process.env.VUE_APP_REQUEST_TIMEOUT) || 30000

/** 请求是否携带 cookie */
export const WITH_CREDENTIALS = toBool(process.env.VUE_APP_WITH_CREDENTIALS, true)

/** 在线接口测试网关使用的协议 */
export const GATEWAY_SCHEME = process.env.VUE_APP_GATEWAY_SCHEME || 'https'

/**
 * 站点访问前缀（部署在子路径时配置 VUE_APP_BASE_PATH，例如 /xxx → 访问地址 http://host/xxx/）。
 * 归一化与读取逻辑集中在 src/seo/site.js，构建端（webpack / 预渲染）与浏览器端共用一份。
 * 根路径部署为 ''（路由 base 回退为 '/'）。
 */
export const BASE_PATH = site.basePath

export default {
  API_BASE_URL,
  REQUEST_TIMEOUT,
  WITH_CREDENTIALS,
  GATEWAY_SCHEME,
  BASE_PATH
}



// WEBPACK FOOTER //
// ./src/config/index.js